import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SWAL } from 'src/app/app-const';
import { SettingsUnit } from 'src/app/core/backend/pm/models';
import { SettingsUnitsService } from 'src/app/core/backend/pm/services';
import { UnitsService } from 'src/app/core/services/units.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'mg-units-form',
  standalone: true,
  imports: [
    CommonModule,
    NzFormModule,
    ReactiveFormsModule,
    NzToolTipModule,
    NzInputModule,
  ],
  templateUrl: './units-form.component.html',
  styleUrls: ['./units-form.component.scss']
})
export class UnitsFormComponent {

  projectId = '';
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public unitsService: UnitsService,
    public settingUnitService: SettingsUnitsService,
  ) {
    this.getData(1);
  }
  filters = {
    search: ''
  };


  gettingData = false;
  categories: SettingsUnit[] = [];
  getData(page?: number) {
    this.gettingData = true;
    this.unitsService.get().subscribe({
      next: (res) => {
        this.gettingData = false;
        this.categories = res || [];
      },
      error: () => {
        this.gettingData = false;
      },
    })

  }




  // ?? === FOORM ===========
  form = new FormGroup({
    id: new FormControl<string | undefined | null>(undefined),
    name: new FormControl<string | undefined | null>(undefined, Validators.required),
  })

  submitting = false;
  onSubmit() {

    if (this.form.valid) {
      if (this.form.value.id) {
        this.submitting = true;
        this.settingUnitService.apiSettingsUnitsUpdateSettingsUnitPatch({
          body: {
            id: this.form.value.id,
            name: this.form.value.name || '',
          }
        }).subscribe({
          next: (res) => {
            this.form.reset();
            this.submitting = false;
            this.successState();
            this.getData(1);
            this.unitsService.get(true).subscribe()
          },
          error: (res) => {
            this.submitting = false;
            SWAL('error', res?.errorCode)
          },
        })
      } else {
        this.submitting = true;
        this.settingUnitService.apiSettingsUnitsCreateSettingsUnitPost({
          body: {
            name: this.form.value.name || '',
          }
        }).subscribe({
          next: (res) => {
            this.submitting = false;
            this.form.reset();
            this.unitsService.get(true).subscribe()
            this.successState();

          },
          error: (res) => {
            this.submitting = false;
            SWAL('error', res?.errorCode)
          },
        })
      }
    } else {
      Object.values(this.form.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }



  }


  setToEdit(org: SettingsUnit) {
    this.form.patchValue({
      id: org.id,
      name: org.name,
    })
  }

  showDeleteConfirmation(id: string | undefined) {
    if (id) {
      Swal.fire({
        title: 'هل أنت متأكد من الحذف؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'حــذف',
        cancelButtonText: 'إلغــاء',
      }).then((result) => {
        if (result.isConfirmed) {

          this.settingUnitService.apiSettingsUnitsDeleteSettingsUnitDelete({
            body: {
              id,
            }
          }).subscribe({
            next: (res) => {
              SWAL('success', 'تم الحذف')
              this.unitsService.get(true).subscribe()
            },
            error: (res) => {
              this.submitting = false;
              SWAL('error', res?.errorCode)
            },
          })
        }
      });
    }
  }


  successed = false;
  successState() {
    this.successed = true;
    setTimeout(() => {
      this.successed = false;
    }, 1500);
  }
}
